// extracted by mini-css-extract-plugin
module.exports = {"google":"google-26D4q","facebook":"facebook-2yXEg"};